import { Component, OnInit } from '@angular/core';
import { AmplitudeService } from '../../shared/services/amplitude.service';

@Component({
  selector: 'cc-onboarding-welcome',
  templateUrl: './onboarding-welcome.component.html',
  styleUrls: ['./onboarding-welcome.component.scss']
})
export class OnboardingWelcomeComponent implements OnInit {
  constructor(private amplitudeService: AmplitudeService) {}

  ngOnInit() {
    this.amplitudeService.logEvent('Panel:Onboarding: Init view');
  }
}
